//import Vue from 'vue';
//import { PiniaVuePlugin, createPinia } from 'pinia';
import { useAuthStore } from "@/stores/authentication.ts";
//import { useNotificationStore } from "@/stores/notification.ts";
import { useAppearanceStore } from "@/stores/appearance.ts";
import { useErrorsStore } from "@/stores/errors.ts";
import { useSuccessStore } from "@/stores/success.ts";
import { usePreferencesStore } from "@/stores/preferences.ts";
import { useCompaniesStore } from "@/stores/companies.ts";
import { useVersioningStore } from "@/stores/versioning.ts";

//Vue.use(PiniaVuePlugin);

//export const pinia = createPinia();

// Boot function to initialize all stores
export const bootStores = () => {
  const authStore = useAuthStore();
  //  const notificationStore = useNotificationStore();
  const appearanceStore = useAppearanceStore();
  const errorsStore = useErrorsStore();
  const successStore = useSuccessStore();
  const preferencesStore = usePreferencesStore();
  const companiesStore = useCompaniesStore();
  const versioningStore = useVersioningStore();

  // Load persisted state from localStorage
  if (localStorage.getItem('store')) {
    try {
      const persistedState = JSON.parse(localStorage.getItem('store') as string);
      
      // Restore each store's state
      if (persistedState.authentication) {
        authStore.$patch(persistedState.authentication);
      }
      //if (persistedState.notification) {
      //notificationStore.$patch(persistedState.notification);
      //}
      if (persistedState.appearance) {
        appearanceStore.$patch(persistedState.appearance);
      }
      if (persistedState.error) {
        errorsStore.$patch(persistedState.error);
      }
      if (persistedState.success) {
        successStore.$patch(persistedState.success);
      }
      if (persistedState.preferences) {
        preferencesStore.$patch(persistedState.preferences);
      }
      //      if (persistedState.companies) {
      //        companiesStore.$patch(persistedState.companies);
      //      }
      if (persistedState.version) {
        versioningStore.$patch(persistedState.version);
      }
    } catch (error) {
      console.error('Failed to restore persisted state:', error);
    }
  }

  // Initialize stores
  authStore.jobs.checking = false;
  authStore.jobs.check = null;
  
  // Call initialization methods
  authStore.validateAuth();
  //notificationStore.closeMessage();
  errorsStore.closeError();
  //  companiesStore.loadCompanies();
  versioningStore.checkInternalVersions();
  versioningStore.bootVersion();
  
  const useBrowserTime = preferencesStore.timezone == null ? false : preferencesStore.timezone.useBrowserTime;
  preferencesStore.updateTimezone(useBrowserTime);
};

// Optional: Auto-persist state to localStorage
export const setupStatePersistence = () => {
  const authStore = useAuthStore();
  //const notificationStore = useNotificationStore();
  const appearanceStore = useAppearanceStore();
  const errorsStore = useErrorsStore();
  const successStore = useSuccessStore();
  const preferencesStore = usePreferencesStore();
  const companiesStore = useCompaniesStore();
  const versioningStore = useVersioningStore();

  const saveState = () => {
    const state = {
      authentication: authStore.$state,
      //notification: notificationStore.$state,
      appearance: appearanceStore.$state,
      error: errorsStore.$state,
      success: successStore.$state,
      preferences: preferencesStore.$state,
      //      companies: companiesStore.$state,
      version: versioningStore.$state
    };
    localStorage.setItem('store', JSON.stringify(state));
  };

  // Subscribe to changes in each store
  authStore.$subscribe(saveState);
  //notificationStore.$subscribe(saveState);
  appearanceStore.$subscribe(saveState);
  errorsStore.$subscribe(saveState);
  successStore.$subscribe(saveState);
  preferencesStore.$subscribe(saveState);
  companiesStore.$subscribe(saveState);
  versioningStore.$subscribe(saveState);
};
